import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { AccountContext } from "context/account";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiTagInput from "components/SuiTagInput";
import SuiDatePicker from "components/SuiDatePicker";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Checkbox from "@mui/material/Checkbox";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import NumbersIcon from "@mui/icons-material/Numbers";
import ScheduleIcon from "@mui/icons-material/Schedule";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import SubjectOutlinedIcon from "@mui/icons-material/SubjectOutlined";
import InsertInvitationOutlinedIcon from "@mui/icons-material/InsertInvitationOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import CollectionsIcon from "@mui/icons-material/Collections";
import StyleIcon from "@mui/icons-material/Style";
import PaletteIcon from "@mui/icons-material/Palette";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import ClearIcon from "@mui/icons-material/Clear";
import PageviewOutlinedIcon from "@mui/icons-material/PageviewOutlined";

import toast from "react-hot-toast";

import CategoryContext from "context/category-context";

import api from "services/api";
import moment from "moment";

import { DatePicker, Tooltip, Upload } from "antd";
import Prompt from "components/UpStyled/Prompt";
import ColorDropDownMenu from "pages/calendar/components/ColorDropDownMenu";

import { filterParser, matchResourceUrl } from "utils/helper";
import { colorOptions } from "utils/data";
import { handleUploadFiles, getStyleImages, canResizeImageUrl } from "utils/imageHelper";

import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";

import ImportStyleModal2 from "pages/de/project/create-project/components/ImportStyleModal2";
import ImportMoodboardModal from "pages/de/collection/detail/components/ImportMoodboardModal";
import ImportProjectModal from "pages/de/project/components/ImportProjectModal";
import ImportCollectionModal from "pages/de/collection/components/ImportCollectionModal";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import { useNavigate, useLocation } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const POPUP_ZINDEX = 1050;

const notificationOption = [
  {
    label: "5 minutes before",
    value: 300,
  },
  {
    label: "10 minutes before",
    value: 600,
  },
  {
    label: "15 minutes before",
    value: 900,
  },
  {
    label: "30 minutes before",
    value: 1800,
  },
  {
    label: "1 hour before",
    value: 3600,
  },
  {
    label: "1 day before",
    value: 86400,
  },
];

const AddEventModal = React.forwardRef(
  (
    {
      visible,
      handleClose,
      handleOk,
      isEdit = false,
      selectInfo = {},
      handleRefresh = () => {},
      handleAfterOk = () => {},
      refreshDelay = 0,
      selectedType,
    },
    ref
  ) => {
    const [isAllDay, setIsAllDay] = useState(false);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [type, setType] = useState(selectedType ? selectedType : "task");
    const [selectedStartDate, setSelectedStartDate] = useState(moment().startOf("day").toDate());
    const [selectedStartTime, setSelectedStartTime] = useState(moment().startOf("minute").toDate());
    const [selectedEndDate, setSelectedEndDate] = useState(moment().startOf("day").toDate());
    const [selectedEndTime, setSelectedEndTime] = useState(
      moment().startOf("minute").add(30, "minutes").toDate()
    );
    const [userOptions, setUserOptions] = useState([]);
    const [calendarOptions, setCalendarOptions] = useState();
    const [selectedColor, setSelectedColor] = useState({});
    const [addContentVisible, setAddContentVisible] = useState(null);
    const [importStyleVisible, setImportStyleVisible] = useState(false);
    const [importMoodboardVisible, setImportMoodboardVisible] = useState(false);
    const [importProjectVisible, setImportProjectVisible] = useState(false);
    const [importCollectionVisible, setImportCollectionVisible] = useState(false);

    const [selectedResource, setSelectedResource] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);

    const navigate = useNavigate();
    const editorRef = useRef({ current: "" });
    const { pathname, search } = useLocation();
    const todayDate = new Date();

    const {
      register,
      handleSubmit,
      trigger,
      setValue,
      getValues,
      reset,
      watch,
      control,
      formState: { errors },
    } = useForm();

    const account = useContext(AccountContext);

    const {
      tree,
      actions: { findNodeByID, findParents },
    } = useContext(CategoryContext);

    const isOwner = account.id == selectInfo?.event?.extendedProps.owner_id;

    useEffect(() => {
      handleRetrieveCalendars();
    }, []);

    useEffect(() => {
      if (isEdit) {
        //data store in selectInfo.event
        const notifySeconds = selectInfo?.event?.extendedProps?.content?.notification;
        const noticationOpt = notificationOption.find((x) => x.value == notifySeconds) || {};

        let resetPayload = {
          title: selectInfo?.event?.title,
          notification: noticationOpt.value
            ? noticationOpt
            : notifySeconds
            ? { label: "custom", value: notifySeconds }
            : undefined,
          description: selectInfo?.event?.extendedProps?.content?.description,
        };

        setIsAllDay(selectInfo?.event?.allDay);

        setType(selectInfo?.event?.extendedProps?.type);

        setFileList(selectInfo?.event?.extendedProps?.content?.attachFiles || []);

        if (selectInfo?.event?.start) {
          const startDate = selectInfo?.event?.start;
          setSelectedStartDate(startDate);
          setSelectedStartTime(startDate);
        }

        if (selectInfo?.event?.end) {
          const endDate = selectInfo?.event?.end;
          setSelectedEndDate(endDate);
          setSelectedEndTime(endDate);
        }

        if (selectInfo?.event?.extendedProps?.content?.resources) {
          setSelectedResource(selectInfo?.event?.extendedProps?.content?.resources);
        }

        reset(resetPayload);
      } else {
        setIsAllDay(selectInfo?.allDay);

        if (selectInfo?.date) {
          const date = selectInfo?.date;
          setSelectedStartDate(date);
          setSelectedStartTime(date);
          setSelectedEndDate(date);
          setSelectedEndTime(date);
        } else {
          if (selectInfo?.start) {
            const startDate = selectInfo?.start;
            setSelectedStartDate(startDate);
            setSelectedStartTime(startDate);
          }

          if (selectInfo?.end) {
            const endDate = selectInfo?.end;
            setSelectedEndDate(endDate);
            setSelectedEndTime(endDate);
          }
        }
      }

      handleRetrieveUsers();
    }, [isEdit, selectInfo]);

    useEffect(() => {
      const subscription = watch((value, { name, type }) => {
        if (name == "calendar" && type == "change") {
          const defaultColor = value.calendar?.color;
          let colorOpt = colorOptions.find((x) => x.value == defaultColor);
          if (colorOpt?.value) {
            setSelectedColor(colorOpt);
          } else {
            setSelectedColor({
              label: defaultColor,
              value: defaultColor,
            });
          }
        }
      });
      return () => subscription.unsubscribe();
    }, [watch]);

    const handleAddEvent = async (data) => {
      if (selectInfo?.view?.calendar) {
        let calendarApi = selectInfo.view.calendar;
        calendarApi.unselect(); // clear date selection
      }

      if (!data["calendar"].value && !isEdit) {
        return toast.error("Could not find the calendar!");
      }

      let startDate = moment(selectedStartDate).startOf("day");
      if (!isAllDay || type == "reminder") {
        const startDateStr = moment(selectedStartDate).format().slice(0, 10);
        const startTimeStr = moment(selectedStartTime).format().slice(10);

        startDate = moment(startDateStr + startTimeStr);
      }
      setUploading(true);
      try {
        //upload attachment files
        const originalFiles = fileList.map((x) => (x.originFileObj ? x.originFileObj : x));
        const attachFiles = await handleUploadFiles(originalFiles);

        let payload = {
          title: data["title"] || "No Title",
          start_time: startDate,
          content: {
            description: data["description"],
            allDay: type != "reminder" ? isAllDay : false,
            notification: data["notification"]?.value,
            resources: selectedResource,
            attachFiles: attachFiles,
          },
          color: selectedColor?.value,
          calendar_id: data["calendar"].value,
          type: type,
        };

        if (type == "task" && !selectInfo?.event?.extendedProps?.status) {
          payload["status"] = "uncompleted";
        }

        if (type != "reminder") {
          let endDate = moment(selectedEndDate).startOf("day");
          if (!isAllDay) {
            const endDateStr = moment(selectedEndDate).format().slice(0, 10);
            const endTimeStr = moment(selectedEndDate).format().slice(10);
            endDate = moment(endDateStr + endTimeStr);
          }
          payload["end_time"] = endDate;
        }

        if (isEdit) {
          if (!selectInfo?.event?.id) {
            setUploading(false);
            return toast.error("Could not find the event ID!");
          }
          const newCreatedEvent = await api.calendar.updateEvent(selectInfo?.event?.id, payload);
          toast.success(`${isEdit ? "Edit event" : "Create new event"} successfully!`);
          handleClose();
          handleAfterOk(newCreatedEvent);
        } else {
          const newCreatedEvent = await api.calendar.createEvent(payload);
          toast.success(`${isEdit ? "Edit event" : "Create new event"} successfully!`);

          handleClose();
          handleAfterOk(newCreatedEvent);
        }
        setUploading(false);
        setTimeout(() => {
          handleRefresh();
        }, refreshDelay);
      } catch (err) {
        setUploading(false);
        console.log(err);
        toast.error(`${isEdit ? "Edit event" : "Create new event"} failed!`);
      }
    };

    const handleRetrieveUsers = async (q = "") => {
      try {
        let payload = {
          sort: ["account_status:asc", "profile_update_level:desc"],
          offset: 0,
          limit: 2000,
        };
        payload["q"] = q;
        let myFilter = {};

        myFilter["id"] = { neq: [account.id, "AllDesigners"] };

        const newFilterStr = filterParser(myFilter);
        if (newFilterStr) {
          payload["filter"] = newFilterStr;
        }
        const { data } = await api.users.search(payload);
        const userList = data?.hits || [];
        let options = [];
        for (let i = 0; i < userList.length; i++) {
          const store = userList[i]?.stores[0];
          let record = {
            label: store.name,
            value: userList[i].email,
            description: userList[i].email,
          };
          options.push(record);
        }

        setUserOptions(options);
      } catch (err) {
        console.log(err);
        toast.error("Retrieve user list failed!");
      }
    };

    const handleRetrieveCalendars = async () => {
      try {
        const temp = await api.calendar.listCalendars({ order: "created_at" });
        const calendars = temp?.data?.calendars || [];
        const myCalendarOptions = calendars.map((x) => ({
          value: x.id,
          label: x.title,
          color: x?.setting?.color || "#abe9f7",
        }));
        setCalendarOptions(myCalendarOptions);
        if (myCalendarOptions.length > 0) {
          if (isEdit) {
            const selectedCalendar = myCalendarOptions.find(
              (x) => x.value == selectInfo.event?.extendedProps?.calendar_id
            );
            setValue("calendar", selectedCalendar);
          } else {
            setValue("calendar", myCalendarOptions[0]);
          }

          const defaultColor = isEdit
            ? selectInfo?.event?.backgroundColor
            : myCalendarOptions[0]?.color;
          let colorOpt = colorOptions.find((x) => x.value == defaultColor);
          if (colorOpt?.value) {
            setSelectedColor(colorOpt);
          } else {
            setSelectedColor({
              label: defaultColor,
              value: defaultColor,
            });
          }
        }
      } catch (err) {
        console.log(err);
        toast.error(`Could not retrieve calendars!`);
      }
    };

    const handleConfirmDelete = async () => {
      try {
        await api.calendar.deleteEvent(selectInfo?.event?.id);
        handleRefresh();
        setDeleteVisible(false);
        handleClose();
        toast.success(`Delete event:${selectInfo?.event?.title} successfully!`);
      } catch (err) {
        toast.error(`Delete event:${selectInfo?.event?.title} failed!`);
        console.log(err);
      }
    };

    const handleUploadAttachmentChange = (info) => {
      console.log(info);
      let newFileList = info.fileList.map((x) => ({
        ...x,
        path: x.name,
        status: "done",
      }));

      setFileList(newFileList);
    };

    const handleMarkStatus = async (status) => {
      if (selectInfo?.view?.calendar) {
        let calendarApi = selectInfo.view.calendar;
        calendarApi.unselect(); // clear date selection
      }

      try {
        let payload = {
          status: status,
        };

        if (!selectInfo?.event?.id) {
          return toast.error("Could not find the event ID!");
        }
        const newCreatedEvent = await api.calendar.updateEvent(selectInfo?.event?.id, payload);
        toast.success(`Mark ${status} successfully!`);
        handleClose();
        handleAfterOk(newCreatedEvent);

        setTimeout(() => {
          handleRefresh();
        }, refreshDelay);
      } catch (err) {
        console.log(err);
        toast.error(`Mark ${status} failed!`);
      }
    };

    const handleAddStyles = (styles) => {
      let newStyles = [...selectedResource];
      newStyles = newStyles.filter((x) => x.resourceType != "style");

      for (let i = 0; i < styles.length; i++) {
        const findOne = newStyles.find((x) => x.id == styles[i].id);
        if (!findOne?.id) {
          newStyles.push({
            id: styles[i].id,
            title: styles[i].title,
            style: styles[i].style,
            resourceType: "style",
          });
        }
      }
      setSelectedResource(newStyles);
      setImportStyleVisible(false);
    };

    const handleAddMoodboards = (moodboards) => {
      let newMoodboards = [...selectedResource];
      //remove moodboards
      newMoodboards = newMoodboards.filter((x) => x.resourceType != "moodboard");
      for (let i = 0; i < moodboards.length; i++) {
        newMoodboards.push({
          id: moodboards[i].id,
          name: moodboards[i].name,
          img: moodboards[i].img || {},
          resourceType: "moodboard",
        });
      }
      setSelectedResource(newMoodboards);
      setImportMoodboardVisible(false);
    };

    const handleAddProjects = (projects) => {
      console.log(projects);
      let newProjects = [...selectedResource];
      //remove projects
      newProjects = newProjects.filter((x) => x.resourceType != "project");
      for (let i = 0; i < projects.length; i++) {
        newProjects.push({
          id: projects[i].id,
          name: projects[i].name,
          products: projects[i].products || [],
          resourceType: "project",
        });
      }
      setSelectedResource(newProjects);
      setImportProjectVisible(false);
    };

    const handleAddCollections = (collections) => {
      console.log(collections);
      let newCollections = [...selectedResource];
      //remove projects
      newCollections = newCollections.filter((x) => x.resourceType != "collection");
      for (let i = 0; i < collections.length; i++) {
        newCollections.push({
          id: collections[i].id,
          title: collections[i].title,
          products: collections[i].products || [],
          moodboard: collections[i].moodboard || [],
          resourceType: "collection",
        });
      }
      setSelectedResource(newCollections);
      setImportCollectionVisible(false);
    };

    const handleCloseMenu = () => setAddContentVisible(null);
    const ActionMenu = ({}) => (
      <Menu
        id="action-menu"
        anchorEl={addContentVisible}
        open={Boolean(addContentVisible)}
        onClose={handleCloseMenu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {account.account_type == "de" ? (
          <div>
            <MenuItem
              onClick={() => {
                handleCloseMenu();
                setImportMoodboardVisible(true);
              }}
            >
              <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={1}>
                <PaletteIcon fontSize="small" />
                <SuiTypography variant="body1" textAlign="center">
                  Add Moodboard
                </SuiTypography>{" "}
              </SuiBox>
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleCloseMenu();
                setImportCollectionVisible(true);
              }}
            >
              <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={1}>
                <CollectionsIcon fontSize="small" />
                <SuiTypography variant="body1" textAlign="center">
                  Add Collection
                </SuiTypography>{" "}
              </SuiBox>
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleCloseMenu();
                setImportStyleVisible(true);
              }}
            >
              <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={1}>
                <StyleIcon fontSize="small" />
                <SuiTypography variant="body1" textAlign="center">
                  Add Style
                </SuiTypography>{" "}
              </SuiBox>
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleCloseMenu();
                setImportProjectVisible(true);
              }}
            >
              <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={1}>
                <PrecisionManufacturingIcon fontSize="small" />
                <SuiTypography variant="body1" textAlign="center">
                  Add Project
                </SuiTypography>{" "}
              </SuiBox>
            </MenuItem>
          </div>
        ) : null}
        {account.account_type == "ma" ? (
          <MenuItem
            onClick={() => {
              handleCloseMenu();
              setImportProjectVisible(true);
            }}
          >
            <SuiBox display="flex" alignItems="center" justifyContent="flex-start" gap={1}>
              <PrecisionManufacturingIcon fontSize="small" />
              <SuiTypography variant="body1" textAlign="center">
                Add Project
              </SuiTypography>{" "}
            </SuiBox>
          </MenuItem>
        ) : null}
      </Menu>
    );

    return (
      <Dialog
        open={visible}
        onClose={(e, reason) => {
          if (reason != "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth={true}
        style={{ zIndex: POPUP_ZINDEX }}
        disableEnforceFocus
      >
        <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploading}>
          <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
          <SuiTypography variant="h6" fontWeight="medium" color="info">
            Uploading supporting files...
          </SuiTypography>
        </Backdrop>
        <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
          {isEdit ? `Edit ${type}` : `Create ${type}`}

          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <form
          onSubmit={handleSubmit(handleOk ? handleOk : handleAddEvent)}
          style={{ overflow: "auto" }}
        >
          {" "}
          <fieldset disabled={isEdit && !isOwner}>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <SuiBox sx={{ px: 1 }}>
                  <SuiBox mb={0.5} sx={{ width: "100%" }}>
                    <SuiBox ml={4}>
                      <SuiInput
                        placeholder="Add title"
                        required
                        inputProps={{ maxLength: 200 }}
                        {...register("title")}
                      />
                    </SuiBox>
                  </SuiBox>
                  {selectedType ? null : (
                    <SuiBox ml={4} my={0.5}>
                      <Stack spacing={2} direction="row">
                        {["task", "event", "reminder"].map((x, index) => (
                          <SuiButton
                            variant="text"
                            size="large"
                            color={type == x ? "info" : "text"}
                            sx={{
                              backgroundColor: type == x ? rgba(colors.info.main, 0.2) : "none",
                              "&:hover": {
                                backgroundColor: rgba(colors.text.main, 0.1),
                                textDecoration: "none",
                              },
                              "&:focus": { backgroundColor: rgba(colors.info.main, 0.1) },
                              textTransform: "capitalize",
                            }}
                            onClick={() => {
                              if (x == "reminder" && !isEdit) {
                                setIsAllDay(false);
                                setSelectedStartTime(moment().startOf("minute").toDate());
                                setSelectedEndTime(
                                  moment().startOf("minute").add(30, "minutes").toDate()
                                );
                              }

                              const usedColors = calendarOptions.map((x) => x.color);
                              //using calendar default color
                              const colorValue = selectInfo?.event?.backgroundColor
                                ? selectInfo?.event?.backgroundColor
                                : getValues("calendar");
                              const defaultColor = colorValue?.color || colorValue;

                              //it's own event color

                              if (
                                x == selectInfo?.event?.extendedProps?.type ||
                                (!isEdit && x == "task")
                              ) {
                                //using calendar default color

                                let colorOpt = colorOptions.find((x) => x.value == defaultColor);

                                if (colorOpt?.value) {
                                  setSelectedColor(colorOpt);
                                } else {
                                  setSelectedColor({
                                    label: defaultColor,
                                    value: defaultColor,
                                  });
                                }
                              } else {
                                //use next available color
                                let colorIndex = colorOptions.findIndex(
                                  (item) => item.value == selectedColor.value
                                );
                                const newIndex = (colorIndex + index + 1) % colorOptions.length;

                                setSelectedColor(colorOptions[newIndex]);
                              }

                              setType(x);
                            }}
                          >
                            {x}
                          </SuiButton>
                        ))}
                      </Stack>
                    </SuiBox>
                  )}

                  <SuiBox my={0.5}>
                    <SuiBox display="flex" alignItems="center" gap={1}>
                      <SuiBox>
                        <ScheduleIcon fontSize="medium" />
                      </SuiBox>
                      <SuiBox>
                        <SuiBox width={155} sx={{ display: "inline-block", mr: 1 }}>
                          <SuiDatePicker
                            value={selectedStartDate}
                            onChange={(e) => setSelectedStartDate(e?.[0])}
                            options={{
                              altInput: true,
                              altFormat: "F j, Y",
                              dateFormat: "Y-m-d",
                            }}
                            input={{
                              placeholder: moment(todayDate).format("MMMM DD,YYYY"),
                            }}
                          />
                        </SuiBox>
                        {isAllDay && type != "reminder" ? null : (
                          <SuiBox width={65} sx={{ display: "inline-block", mr: 1 }}>
                            <div>
                              <SuiDatePicker
                                value={selectedStartTime}
                                onChange={(e) => setSelectedStartTime(e?.[0])}
                                options={{
                                  enableTime: true,
                                  noCalendar: true,
                                  dateFormat: "H:i",
                                  minuteIncrement: 15,
                                }}
                                input={{
                                  placeholder: moment(todayDate).format("HH:mm"),
                                }}
                              />
                            </div>
                          </SuiBox>
                        )}
                        {type == "event" || type == "task" ? (
                          <SuiBox display="inline-block">
                            <SuiBox sx={{ display: "inline-block", mr: 1 }}>-</SuiBox>
                            <SuiBox width={155} sx={{ display: "inline-block", mr: 1 }}>
                              <SuiDatePicker
                                value={selectedEndDate}
                                onChange={(e) => setSelectedEndDate(e?.[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                  minDate: selectedStartDate,
                                }}
                                input={{ placeholder: moment(todayDate).format("MMMM DD,YYYY") }}
                              />
                            </SuiBox>
                            {isAllDay ? null : (
                              <SuiBox width={65} sx={{ display: "inline-block" }}>
                                <SuiDatePicker
                                  value={selectedEndTime}
                                  onChange={(e) => setSelectedEndTime(e?.[0])}
                                  options={{
                                    enableTime: true,
                                    noCalendar: true,
                                    dateFormat: "H:i",
                                    minuteIncrement: 15,
                                  }}
                                  input={{ placeholder: moment(todayDate).format("HH:mm") }}
                                />
                              </SuiBox>
                            )}
                          </SuiBox>
                        ) : null}
                      </SuiBox>
                    </SuiBox>
                    {type != "reminder" ? (
                      <SuiBox
                        display="flex"
                        justifyContent="flex-start"
                        alignItems="center"
                        mt={1}
                        ml={4}
                      >
                        <Checkbox
                          onChange={(e) => {
                            if (isAllDay && !isEdit) {
                              setSelectedStartTime(moment().startOf("minute").toDate());
                              setSelectedEndTime(
                                moment().startOf("minute").add(30, "minutes").toDate()
                              );
                            }
                            setIsAllDay(!isAllDay);
                          }}
                          checked={isAllDay ? true : false}
                        />{" "}
                        all Day
                      </SuiBox>
                    ) : null}
                  </SuiBox>
                  {type == "event_todo" ? (
                    <SuiBox my={0.5}>
                      <SuiBox display="flex" alignItems="center" gap={1}>
                        <SuiBox>
                          <GroupAddOutlinedIcon fontSize="medium" />
                        </SuiBox>
                        <SuiSelect
                          placeholder="Add Guests"
                          options={userOptions}
                          {...register("guests")}
                        />
                      </SuiBox>
                    </SuiBox>
                  ) : null}
                  <SuiBox my={0.5}>
                    <SuiBox display="flex" alignItems="flex-start" gap={1}>
                      <SuiBox>
                        <SubjectOutlinedIcon fontSize="medium" />
                      </SuiBox>
                      <SuiBox width="100%">
                        {type == "event" ? (
                          <Controller
                            name="description"
                            control={control}
                            render={({ field }) => (
                              <ReactQuill placeholder="Add description" theme="snow" {...field} />
                            )}
                          />
                        ) : (
                          <Controller
                            name="description"
                            control={control}
                            render={({ field }) => (
                              <SuiInput
                                placeholder="Add description"
                                rows={3}
                                multiline={true}
                                fullWidth={true}
                                inputProps={{ maxLength: 500 }}
                                {...field}
                              />
                            )}
                          />
                        )}
                      </SuiBox>
                    </SuiBox>
                  </SuiBox>
                  {type == "task" ? (
                    <SuiBox my={0.5}>
                      <SuiBox display="flex" alignItems="flex-start" gap={1}>
                        <SuiBox>
                          <DesignServicesIcon fontSize="medium" />
                        </SuiBox>
                        <SuiBox sx={{ width: "100%" }}>
                          <SuiBox display="flex" sx={{ mb: 1 }}>
                            <SuiTypography
                              variant="body1"
                              color="text"
                              sx={{
                                px: 1,
                                py: 0.5,
                                backgroundColor: "none",
                                "&:hover": {
                                  backgroundColor: rgba(colors.text.main, 0.1),
                                  textDecoration: "none",
                                  transform: `scale(1.02)`,
                                },
                                textTransform: "capitalize",
                                cursor: "pointer",
                                borderRadius: ({ borders: { borderRadius } }) => borderRadius.sm,
                              }}
                              onClick={(e) => setAddContentVisible(e.target)}
                            >
                              Add my work
                            </SuiTypography>
                          </SuiBox>
                          {selectedResource.map((item) => {
                            let img = {};
                            let title = "";
                            if (item.resourceType == "style") {
                              const styleImages = getStyleImages(item, false);
                              img = styleImages[0];
                              title = item?.title;
                            } else if (item.resourceType == "moodboard") {
                              img = item.img;
                              title = item?.name;
                            } else if (item.resourceType == "project") {
                              const products = item?.products || [];
                              let styleImages = [];
                              //add style first image
                              for (let i = 0; i < products.length; i++) {
                                const temp = getStyleImages(products[i], false);
                                styleImages.push(...temp);
                              }
                              img = styleImages[0];
                              title = item?.name;
                            } else if (item.resourceType == "collection") {
                              img = item.moodboard?.[0]?.img;
                              title = item?.title;
                            }

                            return (
                              <SuiBox
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                width="100%"
                                sx={{ mb: 0.5 }}
                              >
                                <SuiBox display="flex" alignItems="center" gap={0.5}>
                                  <SuiBox
                                    sx={{ width: 40, height: 40, cursor: "pointer" }}
                                    onClick={(e) => {
                                      window.open(matchResourceUrl(item), "_blank");
                                    }}
                                  >
                                    <ImageCardWrapper
                                      data={img}
                                      mode={"normal"}
                                      height={40}
                                      width={40}
                                      iconMode
                                    />{" "}
                                  </SuiBox>
                                  <SuiTypography>{title}</SuiTypography>
                                </SuiBox>
                                <SuiBox display="flex" alignItems="center" gap={0.5}>
                                  <SuiBox>
                                    <Tooltip title="View detail">
                                      <PageviewOutlinedIcon
                                        color="dark"
                                        fontSize="small"
                                        sx={{ cursor: "pointer" }}
                                        onClick={(e) => {
                                          window.open(matchResourceUrl(item), "_blank");
                                        }}
                                      />
                                    </Tooltip>{" "}
                                  </SuiBox>
                                  <SuiBox>
                                    <Tooltip title="Remove">
                                      <ClearIcon
                                        color="error"
                                        fontSize="small"
                                        sx={{ cursor: "pointer" }}
                                        onClick={(e) => {
                                          const newSelectedResource = selectedResource.filter(
                                            (x) => x.id != item.id
                                          );
                                          setSelectedResource(newSelectedResource);
                                        }}
                                      />{" "}
                                    </Tooltip>{" "}
                                  </SuiBox>
                                </SuiBox>
                              </SuiBox>
                            );
                          })}
                        </SuiBox>
                      </SuiBox>
                    </SuiBox>
                  ) : null}
                  {type != "reminder" ? (
                    <SuiBox my={0.5}>
                      <SuiBox display="flex" alignItems="flex-start" gap={1}>
                        <SuiBox>
                          <AttachFileOutlinedIcon fontSize="medium" />
                        </SuiBox>
                        <SuiBox display="flex" alignItems="center" gap={1}>
                          <Upload
                            name="attachment"
                            showUploadList={true}
                            onChange={handleUploadAttachmentChange}
                            customRequest={(e) => null}
                            multiple
                            fileList={fileList}
                          >
                            <SuiTypography
                              variant="body1"
                              color="text"
                              sx={{
                                px: 1,
                                py: 0.5,
                                backgroundColor: "none",
                                "&:hover": {
                                  backgroundColor: rgba(colors.text.main, 0.1),
                                  textDecoration: "none",
                                  transform: `scale(1.02)`,
                                },
                                textTransform: "capitalize",
                                cursor: "pointer",
                                borderRadius: ({ borders: { borderRadius } }) => borderRadius.sm,
                              }}
                            >
                              Add attachment
                            </SuiTypography>
                          </Upload>
                        </SuiBox>
                      </SuiBox>
                    </SuiBox>
                  ) : null}
                  <SuiBox my={0.5}>
                    <SuiBox display="flex" alignItems="center" gap={1}>
                      <SuiBox>
                        <InsertInvitationOutlinedIcon fontSize="medium" />
                      </SuiBox>
                      <SuiBox display="flex" gap={1} alignItems="center">
                        <Controller
                          name="calendar"
                          control={control}
                          render={({ field }) => (
                            <SuiSelect
                              {...field}
                              options={calendarOptions}
                              placeholder="Calendar"
                              backspaceRemovesValue
                            />
                          )}
                        />
                        <ColorDropDownMenu
                          color={selectedColor}
                          onClick={(color) => setSelectedColor(color)}
                        />
                      </SuiBox>
                    </SuiBox>
                  </SuiBox>
                  {type == "event" ? (
                    <SuiBox my={0.5}>
                      <SuiBox display="flex" alignItems="center" gap={1}>
                        <SuiBox>
                          <NotificationsOutlinedIcon fontSize="medium" />
                        </SuiBox>
                        <SuiBox display="flex" alignItems="center" gap={1}>
                          <Controller
                            name="notification"
                            control={control}
                            render={({ field }) => (
                              <SuiSelect
                                {...field}
                                options={notificationOption}
                                placeholder="Add Notification"
                                backspaceRemovesValue
                              />
                            )}
                          />
                          <ClearOutlinedIcon
                            fontSize="small"
                            color="text"
                            sx={{ cursor: "pointer" }}
                            onClick={(e) => {
                              setValue("notification", null);
                            }}
                          />
                        </SuiBox>
                      </SuiBox>
                    </SuiBox>
                  ) : null}
                </SuiBox>

                <SuiBox
                  pt={3}
                  px={3}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems={"center"}
                  gap={1}
                >
                  <SuiButton size="medium" variant="text" color="dark" onClick={handleClose}>
                    Cancel
                  </SuiButton>
                  <SuiButton size="medium" variant="gradient" color="dark" type="submit">
                    {isEdit ? "Save" : "Create"}
                  </SuiButton>
                </SuiBox>
              </DialogContentText>
            </DialogContent>
          </fieldset>
        </form>
        {deleteVisible && selectInfo?.event?.id ? (
          <Prompt
            heading="Delete Event"
            text={`Are you sure you want to delete the event: ${selectInfo?.event?.title}`}
            visible={deleteVisible}
            okText="Delete"
            okColor="error"
            handleOk={() => {
              handleConfirmDelete();
            }}
            handleClose={() => setDeleteVisible(false)}
            option={{ sx: { zIndex: POPUP_ZINDEX + 2 } }}
          />
        ) : null}

        {importStyleVisible ? (
          <ImportStyleModal2
            handleClose={() => setImportStyleVisible(false)}
            visible={importStyleVisible}
            isEdit={false}
            categoryTree={tree}
            handleRefresh={() => {
              handleRefresh();
            }}
            handleOk={handleAddStyles}
            selectedItems={selectedResource.filter((x) => x.resourceType == "style")}
          />
        ) : null}
        {importMoodboardVisible ? (
          <ImportMoodboardModal
            visible={importMoodboardVisible}
            handleClose={() => setImportMoodboardVisible(false)}
            handleOk={handleAddMoodboards}
            handleRefresh={handleRefresh}
            selectedMoodboards={selectedResource.filter((x) => x.resourceType == "moodboard")}
            isMulti
          />
        ) : null}
        {importProjectVisible ? (
          <ImportProjectModal
            handleClose={() => setImportProjectVisible(false)}
            visible={importProjectVisible}
            handleRefresh={() => {
              handleRefresh();
            }}
            handleOk={handleAddProjects}
            selectedItems={selectedResource.filter((x) => x.resourceType == "project")}
          />
        ) : null}
        {importCollectionVisible ? (
          <ImportCollectionModal
            handleClose={() => setImportCollectionVisible(false)}
            visible={importCollectionVisible}
            handleRefresh={() => {
              handleRefresh();
            }}
            handleOk={handleAddCollections}
            selectedItems={selectedResource.filter((x) => x.resourceType == "collection")}
          />
        ) : null}

        <ActionMenu />
      </Dialog>
    );
  }
);

export default AddEventModal;
